import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useBooking } from "../context/BookingContext";
import { useLang } from "../context/LanguageContext";

const IMG =
  "https://images.unsplash.com/photo-1562564055-71e051d33c19?crop=entropy&cs=srgb&fm=jpg&q=85";

const CreditRepair = () => {
  const { openBooking } = useBooking();
  const { t } = useLang();

  const steps = [
    { n: "01", title: t("cr.s1t"), text: t("cr.s1d") },
    { n: "02", title: t("cr.s2t"), text: t("cr.s2d") },
    { n: "03", title: t("cr.s3t"), text: t("cr.s3d") },
    { n: "04", title: t("cr.s4t"), text: t("cr.s4d") },
  ];

  return (
    <section id="credit-repair" data-testid="credit-repair-section" className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:py-32">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, x: -32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="engraved-frame bg-white p-3 shadow-elevated">
            <img src={IMG} alt="Credit consultation at DV Luxury Realty" className="aspect-[4/5] w-full object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-4 bg-navy px-6 py-5 text-paper shadow-lifted sm:-right-8">
            <p className="font-serif text-3xl font-bold">620+</p>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-gold">{t("cr.target")}</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="eyebrow">{t("cr.eyebrow")}</p>
          <h2 className="mt-4 font-serif text-3xl font-bold tracking-tight text-navy sm:text-4xl">
            {t("cr.h2a")}<br />{t("cr.h2b")}
          </h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-slate-600">
            {t("cr.body")}
          </p>
          <ol className="mt-9 space-y-6">
            {steps.map((s) => (
              <li key={s.n} className="flex gap-5 border-b border-engraved pb-6 last:border-0">
                <span className="font-serif text-2xl font-bold text-gold">{s.n}</span>
                <div>
                  <p className="font-cinzel text-sm font-bold uppercase tracking-[0.15em] text-navy">{s.title}</p>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{s.text}</p>
                </div>
              </li>
            ))}
          </ol>
          <button
            data-testid="credit-repair-cta-button"
            onClick={() => openBooking({ service: "credit_repair" })}
            className="group mt-9 flex items-center gap-2 bg-crimson px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-paper transition-colors duration-300 hover:bg-navy"
          >
            {t("cr.cta")}
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default CreditRepair;
